import { Box, CSSTransition } from '@chakra-ui/core';
import React, { ReactElement, ReactNode } from 'react';
import { TransitionGroup } from 'react-transition-group';

interface PaginatorProps {
  index: number;
  children?: ReactNode;
}

const getValidChildren = (children: ReactNode) => {
  return React.Children.toArray(children).filter((child) =>
    React.isValidElement(child)
  ) as ReactElement[];
};

const Paginator = ({ index, children }: PaginatorProps) => {
  return (
    <TransitionGroup exit={false}>
      <CSSTransition timeout={500} classNames="fade" key={index}>
        <Box>{getValidChildren(children).filter((_, i) => i === index)}</Box>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Paginator;
